// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__Xcn4A","buttons":"RemoveExpirationActionButtons_buttons__2HhGb"};